/* import __COLOCATED_TEMPLATE__ from './client-form.hbs'; */
import { MODE_CONTACT } from 'client-portal/utils/prescreener/constants';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class ContactInformationClientForm extends Component {
  @service session;
  @service prescreener;
  @service currentPractice;

  get modeContact() {
    return MODE_CONTACT;
  }

  get useLegacyPrescreener() {
    return !this.usePrescreenerV2Forms;
  }

  get usePrescreenerV2Forms() {
    return this.prescreener.featurePrescreenerV2;
  }

  @action
  onClientTypeChange(newType) {
    this.resetValidation();
    this.args.onClientTypeChange?.(newType);
  }

  resetValidation() {
    this.prescreener.validation.resetValidation();
    this.resetClientValidation();
  }

  resetClientValidation() {
    if (this.args.client) {
      this.args.client.set('_isDirty', false);
      this.resetRelatedClientValidation();
    }
  }

  resetRelatedClientValidation() {
    const relatedClient = this.args.client
      ?.get('clientRelationships')
      ?.get('firstObject.relatedClient');
    if (relatedClient) {
      relatedClient.set('_isDirty', false);
    }
  }
}
